/**
 * Normalize factory tokens from NDF so they match legacy `EFactory/...` enums
 * (`UnitCategory` etc.). New game data often uses `Factory/...` without the
 * leading `E`, which is semantically identical for deck/patch purposes.
 */
export function canonicalizeFactoryDescriptor(value: string | undefined): string {
  if (!value) return '';
  let v = value.trim().replace(/^['"]|['"]$/g, '').replace(/EDefaultFactories/g, 'EFactory');
  if (v.startsWith('Factory/')) {
    v = `E${v}`;
  }
  return v;
}
